import React,{ useMemo } from 'react';
import { endpoints, poster, fetcherGET, fetcher } from '../utils/axios';

export const faqs = async (params = {}) => {
  try {
    const response = await fetcherGET(`${endpoints.helpcenter.faqs}`, params);
    return response;
  } catch (error) {
    console.error('faqs error:', error);
    var response = {};
    response.status = false;
    response.message = error?.response?.data?.message ?? error.message;
    return response;;
  }
};

export default faqs;